var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PeriodsFetcher',{attrs:{"store-id":_vm.storeId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('BaseSelect',{attrs:{"options":_vm.parsePeriods(data),"reduce":_vm.reduce,"validation":_vm.validation},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }